module.exports = __webpack_public_path__ + "img/er.d6d21b9.svg";